// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1Ck48","footer":"ModalUpdate_footer__24Jvd"};